import type React from "react";
import { Button } from "semantic-ui-react";
import { useT } from "i18n";

export interface UserModalActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
  disabled?: boolean;
}

export default function UserModalActions({
  onCancel,
  onSubmit,
  disabled,
}: UserModalActionsProps): React.ReactElement {
  const t = useT();
  return (
    <div className={"controls"}>
      <Button
        basic
        className={"control-right"}
        content={t("component.common.cancel", "Cancel")}
        onClick={onCancel}
      />
      <Button
        primary
        content={t("component.userModalActions.save", "Save")}
        onClick={onSubmit}
        disabled={disabled}
      />
    </div>
  );
}
